import {
  paletteHelper,
  spacingHelper,
  mediaHelper,
  SITE_HEADER_HEIGHT_PX,
} from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { PageContainer } from '../PageContainer/PageContainer';

export const PageContentContainer = styled.main`
  background-color: ${paletteHelper('backgroundSecondaryBase')};
  padding: ${SITE_HEADER_HEIGHT_PX}px 0 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const PageBodyContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  /*  Needed so footer is always at the bottom */
  justify-content: space-between;
  padding: ${spacingHelper('medium')} 0 0;
`;

export const PageMainBodyContentContainer = styled(PageContainer)`
  flex-grow: 1;
  padding: 0 0 calc(${spacingHelper('extraLarge')} * 2);

  > :not(:last-child) {
    margin-bottom: ${spacingHelper('large')};
  }

  ${mediaHelper('tabletMax')} {
    padding: 0 ${spacingHelper('extraSmall')} calc(${spacingHelper('extraLarge')} * 2);
  }
`;
